import React, { useState } from "react";
import { Button, Form, Input, Table, Tag } from "antd";
import { DownCircleFilled } from "@ant-design/icons";
import {
  Page,
  Text,
  View,
  Document,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../config/firebase";

function DownloadPage() {
  const [form] = Form.useForm();
  const [data, setData] = useState(null);

  const onFinish = async (values) => {
    try {
      const q = query(
        collection(db, "Students"),
        where("email", "==", values?.email)
      );

      const records = await getDocs(q);
      if (records) {
        let students = [];
        records.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          students.push(doc.data());
        });
        debugger;
        console.log("students", students);
        setData([...students]);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const columns = [
    {
      title: "Roll No",
      dataIndex: "rollNumber",
      key: "rollNumber",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Father Name",
      dataIndex: "fname",
      key: "fname",
    },
    {
      title: "CNIC",
      dataIndex: "cnic",
      key: "cnic",
    },
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={"geekblue"} key={status}>
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: () => <Button prefix={<DownCircleFilled />}>Download</Button>,
    },
  ];

  return (
    <>
      <h1>Download Form</h1>
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 600,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Cnic"
          name="cnic"
          rules={[
            {
              required: true,
              message: "Please input your cnic!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please input your email!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 8,
            span: 16,
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ background: "green" }}
          >
            Search
          </Button>
        </Form.Item>
      </Form>

      {data && <Table columns={columns} dataSource={data} />}
    </>
  );
}

export default DownloadPage;
